




import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules'
import { DepositStatus } from '@/modules/deposit/models/deposit-resource.model'

@Component
export default class DepositStatusView extends Vue {
  @Prop({ required: true }) status: DepositStatus
  @Prop({ required: true }) statuses!: { [key in DepositStatus]: string }
  @Prop({ default: false }) dark: boolean

  get statusColor() {
    switch (this.status) {
      case DepositStatus.PAID:
        return 'text-green'
      case DepositStatus.PENDING:
        return 'text-orange'
      case DepositStatus.CANCELLED:
        return 'text-red'
      case DepositStatus.FREEZE:
        return 'text-blue'
      default:
        return ''
    }
  }
}
